import React from 'react'
import { Radio as AntRadio } from 'antd'
import {
  RadioProps as AntRadioProps,
  RadioGroupProps as AntRadioGroupProps
} from 'antd/lib/radio'

import './Radio.module.css'

export type RadioProps = AntRadioProps
export type RadioGroupProps = AntRadioGroupProps

export const Radio: React.FC<RadioProps> = ({
  children,
  name,
  disabled,
  value,
  onChange,
  className,
  checked
}) => {
  const controlledProps = {
    ...(value !== undefined && { value }),
    ...(onChange !== undefined && { onChange })
  }
  return (
    <AntRadio
      className={className}
      disabled={disabled}
      name={name}
      {...controlledProps}
      checked={checked}
    >
      {children}
    </AntRadio>
  )
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  children,
  className,
  name,
  value,
  defaultValue,
  disabled,
  onChange,
  options,
  optionType,
  buttonStyle
}) => {
  const controlledProps = {
    ...(value !== undefined && { value }),
    ...(onChange !== undefined && { onChange })
  }

  return (
    <AntRadio.Group
      name={name}
      className={className}
      options={options}
      defaultValue={defaultValue}
      disabled={disabled}
      optionType={optionType}
      buttonStyle={buttonStyle}
      {...controlledProps}
    >
      {children}
    </AntRadio.Group>
  )
}
